import React, {useMemo, useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'

import NajavaUtovaraModal from './NajavaUtovaraModal'

import {UtovarKamionaModel} from '../../../../models/ProizvodnjaModel'

import {KTCard, KTCardBody, KTIcon} from '../../../../../_websoft/helpers'

import {ToastContainer} from 'react-toastify'

import UtovarKamionaTable from './UtovarKamionaTable'

import logo from '../../../../../_websoft/assets/images/logo.jpg'
// import {postojiLiNajavaUtovara} from '../../../../api/proizvodnja'
import notifyToast from '../../../../components/Toast/Toast'

const parsePackageId = (value: any) => {
    const rawValue = String(value ?? '').trim()

    if (!rawValue) {
        return {
            brojNaloga: '',
            stavka: null,
            paket: '',
        }
    }

    if (rawValue.includes('|')) {
        const pipeParts = rawValue.split('|')
        const rightParts = (pipeParts[1]?.trim() ?? '').split('-')
        const stavka = rightParts[0]?.trim()

        return {
            brojNaloga: pipeParts[0]?.trim() ?? '',
            stavka: stavka && !['null', 'undefined'].includes(stavka.toLowerCase()) ? stavka : null,
            paket: rightParts[1]?.trim() ?? '',
        }
    }

    const parts = rawValue.split('-')
    const stavka = parts[1]?.trim()

    return {
        brojNaloga: parts[0]?.trim() ?? '',
        stavka: stavka && !['null', 'undefined'].includes(stavka.toLowerCase()) ? stavka : null,
        paket: parts[2]?.trim() ?? '',
    }
}

/*
const formatExistingNajavaMessage = (existingNajava: any) => {
    const message = existingNajava?.message ?? 'Najava za paket vec kreirana'
    const paketi = Array.isArray(existingNajava?.paketi)
        ? existingNajava.paketi
        : existingNajava?.paket
            ? [existingNajava.paket]
            : []
    const paketiMessage = paketi.length > 0 ? ` Paketi: ${paketi.join(', ')}` : ''
    const najavaUtovaraId = existingNajava?.najavaUtovaraId ?? existingNajava?.data?.Id
    const idMessage = najavaUtovaraId ? ` (ID najave: ${najavaUtovaraId})` : ''

    return `${message}${paketiMessage}${idMessage}`
}
*/

const getGroupedRobaForBin = (bin: any, robaDetalji: any, existingRows: any[] = []) => {
    const grouped: any = {}
    const existingByKey = existingRows.reduce((rows: any, row: any) => {
        rows[`${row.brojNaloga}|${row.stavka ?? 'null'}`] = row

        return rows
    }, {})

    bin?.items?.forEach((item: any) => {
        const parsed = parsePackageId(item.id)
        const key = `${parsed.brojNaloga}|${parsed.stavka ?? 'null'}`
        const apiData = robaDetalji[key] ?? {}

        if (!grouped[key]) {
            const existing = existingByKey[key] ?? {}

            grouped[key] = {
                brojNaloga: parsed.brojNaloga,
                stavka: parsed.stavka,
                brojPonude: item.id?.split('|')?.[1]?.trim()?.split('-')?.[2] ?? '',
                sifra: apiData?.artikal ?? existing.sifra ?? '-',
                boja:
                    apiData?.boja_gore || apiData?.boja_dole
                        ? `${apiData?.boja_gore?.BojaNaziv ?? '-'} / ${apiData?.boja_dole?.BojaNaziv ?? '-'}`
                        : existing.boja ?? '-',
                paketi: [],
                napomena: existing.napomena ?? '',
                istovar: existing.istovar ?? '',
            }
        }

        grouped[key].paketi.push(parsed.paket)
    })

    return Object.values(grouped)
}

const getTruckPackageChecks = (bin: any) =>
    (bin?.items ?? [])
        .map((item: any) => parsePackageId(item.id))
        .filter((paket: any) => paket.brojNaloga && paket.paket)

const getTruckUniqueCounts = (bin: any) => {
    const paketi = getTruckPackageChecks(bin)
    const brojeviNaloga = new Set<string>()
    const nalogStavke = new Set<string>()

    paketi.forEach((paket: any) => {
        brojeviNaloga.add(paket.brojNaloga)
        nalogStavke.add(`${paket.brojNaloga}|${paket.stavka ?? 'null'}`)
    })

    return {
        paketi,
        brojNalogaCount: brojeviNaloga.size,
        nalogStavkaCount: nalogStavke.size,
    }
}

const UtovarKamiona = () => {
    const maxNajavaUtovaraNaloga = 5
    const maxNajavaUtovaraStavki = 5

    const location = useLocation()

    const data: UtovarKamionaModel = location.state.data
    const kupac: string = location.state.kupac
    const binsPacked = useMemo(() => data.bins_packed ?? [], [data.bins_packed])

    const bin_data = binsPacked[0]?.bin_data ?? {}

    const [showModal, setShowModal] = useState(false)
    const [checkingNajavaUtovara, setCheckingNajavaUtovara] = useState(false)
    const [robaDetalji, setRobaDetalji] = useState<any>({})
    // ----------------------------------------------------
    // GROUP PRODUCTS
    // ----------------------------------------------------

    const [groupedRobaByTruck, setGroupedRobaByTruck] = useState<any[][]>([])
    useEffect(() => {
        setGroupedRobaByTruck((prev) =>
            binsPacked.map((bin: any, index: number) =>
                getGroupedRobaForBin(bin, robaDetalji, prev[index])
            )
        )
    }, [binsPacked, robaDetalji])

    const openNajavaUtovaraModal = async () => {
        const truckChecks = binsPacked.map(getTruckUniqueCounts)
        const invalidTruckByNalog = truckChecks.findIndex(
            (truck) => truck.brojNalogaCount > maxNajavaUtovaraNaloga
        )
        const invalidTruckByStavke = truckChecks.findIndex(
            (truck) => truck.nalogStavkaCount > maxNajavaUtovaraStavki
        )

        if (invalidTruckByNalog !== -1) {
            notifyToast(
                false,
                `Kamion ${
                    invalidTruckByNalog + 1
                }: najava utovara moze sadrzavati najvise ${maxNajavaUtovaraNaloga} razlicitih broja naloga.`
            )

            return
        }

        if (invalidTruckByStavke !== -1) {
            notifyToast(
                false,
                `Kamion ${
                    invalidTruckByStavke + 1
                }: najava utovara moze sadrzavati najvise 5 razlicitih stavki naloga.`
            )

            return
        }

        setCheckingNajavaUtovara(true)

        try {
            // Provjera postojece najave utovara je privremeno iskljucena.
            /*
            const checks = await Promise.all(
                truckChecks
                    .flatMap((truck) => truck.paketi)
                    .map((paket) =>
                        postojiLiNajavaUtovara({
                            brojNaloga: paket.brojNaloga,
                            stavka: paket.stavka,
                            paket: paket.paket,
                        })
                    )
            )

            const existingNajava = checks.find((check) => check?.exists === true)

            if (existingNajava) {
                notifyToast(false, formatExistingNajavaMessage(existingNajava))

                return
            }
            */

            setShowModal(true)
        } catch (error: any) {
            console.error(error)

            notifyToast(
                false,
                error?.response?.data?.message ?? 'Greska prilikom provjere najave utovara.'
            )
        } finally {
            setCheckingNajavaUtovara(false)
        }
    }

    return (
        <>
            <KTCard>
                <ToastContainer/>

                <KTCardBody className='py-4'>
                    <div className='d-flex justify-content-end mb-5'>
                        <button
                            className='btn btn-primary'
                            onClick={openNajavaUtovaraModal}
                            disabled={checkingNajavaUtovara}
                        >
                            <KTIcon iconName='truck' className='fs-2'/>
                            {checkingNajavaUtovara ? 'Provjera...' : 'Najava utovara'}
                        </button>
                    </div>

                    <div className='col p-5 mb-6'>
                        <img src={logo} alt='' width={300} className='py-5'/>

                        <div className='col mb-6 h1 py-5'>Kupac: {kupac}</div>

                        <div className='col mb-6 h1'>
                            Dimenzije prikolice: {bin_data.w} X {bin_data.h} X {bin_data.d}
                        </div>

                        {data.bins_packed.map((item, index) => (
                            <React.Fragment key={index}>
                                <UtovarKamionaTable
                                    data={item}
                                    kamion={index + 1}
                                    robaDetalji={robaDetalji}
                                    setRobaDetalji={setRobaDetalji}
                                />

                                <div className='separator'></div>
                            </React.Fragment>
                        ))}
                    </div>
                </KTCardBody>
            </KTCard>

            <NajavaUtovaraModal
                showModal={showModal}
                onClose={() => setShowModal(false)}
                initialKupac={kupac}
                groupedRobaByTruck={groupedRobaByTruck}
                setGroupedRobaByTruck={setGroupedRobaByTruck}
                binsPacked={binsPacked}
            />
        </>
    )
}

export default UtovarKamiona
